import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';

import { AuthModal } from 'interfaces/auth';

import { Button } from 'components/_basic/Button/Button';
import { useAuthModalsContext } from 'components/AuthModals';

import styles from './UnauthorizedSaveProject.module.scss';

export const UnauthorizedSaveProject: FC = () => {
  const { t } = useTranslation();

  const { setAuthModal, setIsModalOpened } = useAuthModalsContext();

  const signupModalHandler = (): void => {
    setAuthModal(AuthModal.SIGN_UP);
    setIsModalOpened(true);
  };

  const loginModalHandler = (): void => {
    setAuthModal(AuthModal.LOGIN);
    setIsModalOpened(true);
  };

  return (
    <Box className={styles.wrapper}>
      <Typography variant="h3" className={styles.title}>
        {t('saveYourNewProject')}
      </Typography>
      <Typography variant="body1" className={styles.text}>
        {t('loginInOrderToSaveTheProject')}
      </Typography>
      <Box className={styles.buttonWrapper}>
        <Button onClick={loginModalHandler} className={styles.button} variant="text" color="primary">
          {t('logIn')}
        </Button>
        <Button onClick={signupModalHandler} className={styles.button} variant="text" color="primary">
          {t('signUp')}
        </Button>
      </Box>
    </Box>
  );
};
